<template>
    <div class="row">
        <div class="col-md-12">
            <b-overlay :show="isLoading" rounded="sm">
                <div class="row">
                    <div class="col-md-6">
                        <dl class="row mb-0 font-size-14">
                            <dt class="col-sm-4">Nº expediente</dt>
                            <dd class="col-sm-8">: {{data.numero_referencia}}</dd>

                            <dt class="col-sm-4">Nº folios</dt>
                            <dd class="col-sm-8">: {{data.folios}}</dd>

                            <dt class="col-sm-4">Fecha registro</dt>
                            <dd class="col-sm-8">: {{$formatDate(data.created_at)}}</dd>
                            <dt class="col-sm-4">Archivos adjuntos:</dt>
                            <dd class="col-sm-8">
                                <div v-for="(datax,index) in data.archivos" v-bind:key="index">
                                    <a :href="server + '/storage/' + datax.nombre" target="_blank">
                                        <i
                                                class="mdi mdi-cloud-download"
                                                style="font-size: 20px;color: #000000"
                                        />
                                        {{datax.nombre_original}}
                                    </a>


                                </div>

                            </dd>
                        </dl>
                    </div>
                    <div  class="col-md-6">
                        <dl class="row mb-0 font-size-14">
                            <dt class="col-sm-4">Nombre</dt>
                            <dd class="col-sm-8">: {{data.denominacion}}</dd>

                            <dt class="col-sm-4">Correo</dt>
                            <dd class="col-sm-8">: {{data.correo}}</dd>

                            <dt class="col-sm-4">Celular</dt>
                            <dd class="col-sm-8">: {{data.celular}}</dd>

                            <dt v-if="(data.documento_identidad_tipo=='01')" class="col-sm-4">DNI</dt>
                            <dt v-if="(data.documento_identidad_tipo=='06')" class="col-sm-4">RUC</dt>

                            <dd class="col-sm-8">: {{data.documento_identidad_numero}}</dd>
                        </dl>
                    </div>
                </div>
            <br>
            <br>
            <b-tabs content-class="mt-3" justified>
                <b-tab title="Oficina externa">
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label >Oficina externa</label>
                            <input v-model="oficina_externa" class="form-control">
                            <!--<v-select :options="oficinas_externas"
                                      v-model="oficina_externa"

                            />-->

                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label>Observaciones</label>
                            <textarea  class="form-control" v-model="observacion_oficina_externa">
                            </textarea>
                        </div>

                    </div>
                    <b-row align-h="center">
                        <button class="btn btn-info btn-lg m-1"  v-on:click="accionOficinaExterna('derivar')">Derivar</button>
                        <button class="btn btn-info btn-lg m-1"  v-on:click="accionOficinaExterna('recepcionar')">Recepcionar</button>
                    </b-row>


                </b-tab>
                <b-tab title="Enviar correo electrónico">

                    <div class="form-row">
                        <div class="form-group col-md-4">
                            <label>Correo</label>
                            <input class="form-control" v-model="data.correo" readonly/>
                        </div>
                        <div class="form-group col-md-4">
                            <label>Archivos</label>
                            <b-form-file
                                    placeholder="Buscar Archivo"
                                    v-model="archivo_adjunto"
                                    accept="application/pdf"
                            />
                        </div>
                        <div class="form-group col-md-4">
                            <label>Enviar archivos</label>
                            <div class="form-group col-md-12" v-for="(data,index) in data.archivos"  v-bind:key="index">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="formCheck2" checked="" disabled>
                                    <label class="form-check-label" for="formCheck2">
                                        {{ data.nombre_original }}
                                    </label>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label>Copia</label>
                            <v-select
                                    class="v-select"
                                    :options="usuarios"
                                    v-model="correos_cc"
                                    aria-placeholder="Seleccione"
                                    label="nombre_correo"
                                    :reduce="usuario=>usuario.id"
                                    style="position: relative"
                                    multiple
                                    required>
                            </v-select>
                        </div>
                    </div>
                    <div class="form-row">

                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label>Titulo</label>
                            <input  class="form-control" v-model="titulo" />
                        </div>
                        <div class="form-group col-md-12">
                            <label>Mensaje</label>
                            <textarea  class="form-control" v-model="mensaje">
                            </textarea>
                        </div>
                    </div>
                    <b-row align-h="center">
                        <button class="btn btn-info btn-lg m-1"  v-on:click="enviarMensaje(0)">Enviar</button>
                        <button class="btn btn-info btn-lg m-1"  v-on:click="enviarMensaje(1)">Enviar y finalizar tramite</button>
                    </b-row>
                </b-tab>

                <b-tab title="Archivos internos" >
                    <button class="btn btn-info" v-on:click="subirArchivo">Subir archivos</button>
                    <hr>
                    <table class="table">
                        <thead>
                        <th>Archivo</th>
                        <th>Usuario</th>

                        </thead>
                        <tbody>
                        <tr v-for="(data,index) in data.derivacion.archivos_internos"  v-bind:key="index">
                            <td>
                                <a :href="server + '/storage/' + data.nombre" target="_blank" > {{data.nombre_original}}</a>
                            </td>
                            <td>{{data.usuario_str}}</td>

                        </tr>
                        </tbody>
                    </table>

                </b-tab>

                <b-tab title="Observaciones" >

                    <div class="form-row big-font">
                        <div class="form-group col-md-10">
                            <label>Observacion</label>

                            <textarea v-model="observacion" class="form-control"/>


                        </div>
                        <div class="form-group col-md-2 mt-4">
                            <button class="btn btn-primary" v-on:click="agregarObservacion">Agregar</button>
                        </div>


                    </div>
                    <table class="table">
                        <thead>
                        <th>Observacion</th>
                        <th>Usuario</th>
                        </thead>
                        <tbody>
                        <tr v-for="(data,index) in data.derivacion.observaciones"  v-bind:key="index">
                            <td>
                                 {{data.observacion}}

                            </td>
                            <td>{{data.usuario_str}}</td>

                        </tr>
                        </tbody>
                    </table>

                </b-tab>
                <b-tab title="Generar Documentos">
                    <table class="table">
                        <thead>
                            <th>Plantilla</th>
                            <th>Funcion</th>
                            <th>Codigo carrera</th>
                            <th>Accion</th>
                        </thead>
                        <tbody>
                        <tr v-for="(data,index) in templates"  v-bind:key="index">
                            <td>
                                {{data.filename}}
                            </td>
                            <td>{{data.funcion}}</td>
                            <td>{{data.codigo_carrera}}</td>
                            <td><button class="btn btn-info" v-on:click="generarTemplate(data.id,data.documento_tipo_id)"> Generar </button> </td>
                        </tr>
                        </tbody>
                    </table>
                    <hr>
                    <table class="table">
                        <thead>
                        <th>Archivo</th>
                        <th></th>
                        <th>Accion</th>
                        </thead>
                        <tbody>
                        <tr v-for="(data,index) in data.derivacion.archivos_generados"  v-bind:key="index">
                            <td>
                               <a :href="server + '/storage/' + data.nombre" target="_blank" > {{data.nombre_original}}</a>
                            </td>
                            <td></td>
                            <td></td>
                        </tr>
                        </tbody>
                    </table>

                </b-tab>
            </b-tabs>
            </b-overlay>
        </div>
        <b-modal
                id="modalUpload"
                scrollable
                title="Subir archivo"
                title-class="font-18"
                size="lg"
                no-close-on-esc
                hide-footer
                centered
        >
            <subirArchivos v-on:upload-complete="uploadComplete" />
        </b-modal>


    </div>
    
</template>

<script>
    import subirArchivos from "@/components/subir-archivos";
    export default {
        name: "expediente-acciones",
        props: {
            oficinas:Array,
            data:Object,
            templates: Array
        },
        components:{
            subirArchivos,
        },
        data(){
            return{

                model:{
                    oficina_id:null,
                    file:null
                },
                usuarios:[],
                /////////
                oficina_externa:'',
                observacion_oficina_externa:'',
                //
                isLoading:false,
                rows_process:[],

                ////
                titulo:'',
                mensaje:'',
                correos_cc:'',
                ///
                archivo_adjunto:null,
                server:process.env.VUE_APP_BACKEND,
                observacion:''

            }
        },
        methods:{
            agregarObservacion(){

                this.isLoading=true;
                this.axios.post(process.env.VUE_APP_BACKEND + "/api/expedientes/derivaciones/observaciones",
                    {
                        'observacion':this.observacion,
                        expediente_derivacion_id:this.data.expediente_derivacion_id
                    })
                    .then((response)=>{

                        this.data.derivacion=response.data.derivacion;

                    })
                    .finally(()=>this.isLoading=false)
            },
            subirArchivo(){
                this.$bvModal.show("modalUpload");
            },
            uploadComplete(files){
                this.isLoading=true;
                this.axios.post(process.env.VUE_APP_BACKEND + "/api/expedientes/derivaciones/archivos-internos",
                    {
                        archivos:files,
                        expediente_derivacion_id:this.data.expediente_derivacion_id
                    })
                    .then((response)=>{
                        //this.model=response.data.model;
                        this.data.derivacion=response.data.derivacion;
                        this.$bvModal.hide("modalUpload");
                    })
                    .finally(()=>this.isLoading=false)

            },
            generarTemplate(template_id,documento_tipo_id){
                this.isLoading=true;
                this.axios.post(this.server + '/api/documentos/generar',{
                    'expediente_id':this.data.id,
                    'template_id':template_id,
                    'documento_tipo_id':documento_tipo_id,
                    'expediente_derivacion_id':this.data.expediente_derivacion_id
                })
                .then((response)=>
                {
                    if(response.data.success)
                    {
                        this.$swal('Ok','Se genero el documento','success');
                        this.data.derivacion=response.data.derivacion;
                    }
                    else
                    {
                        this.$swal('Error','No se genero el documento','error');
                    }

                })
                .catch(()=> this.$swal('Error','No genero el documento','error'))
                .finally(()=>this.isLoading=false);

                //window.open(this.server + '/template/'+template_id+'/'+this.data.id + '/' +documento_tipo_id, '_blank');
            },
            forceDownload(blob, filename) {
                    var a = document.createElement('a');
                    a.download = filename;
                    a.href = blob;
                    // For Firefox https://stackoverflow.com/a/32226068
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                },

            enviarMensaje(finalizar_tramite){
                if(this.titulo==''){
                    this.$swal('Cuidado','Escriba un titulo','warning');
                    return;
                }

                this.$swal.fire({
                    title: '¿Esta seguro de enviar el mensaje?',
                    text: "Se enviara el mensaje al correo registrado.",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Si, Enviar el mensaje'
                }).then((result) => {
                    if (result.isConfirmed) {

                        this.isLoading=true;
                        let formData = new FormData();
                        /*   'expediente_id':this.data.id,
                                'tipo_detalle':'oficina_externa',
                                'detalle':accion +" "+ this.oficina_externa,
                                'observacion':this.observacion2*/
                        formData.append('expediente_id',this.data.id);
                        formData.append('tipo_detalle',"mensaje");
                        formData.append('titulo',this.titulo);
                        formData.append('mensaje',this.mensaje);
                        formData.append('correos_cc',this.correos_cc);
                        formData.append('finalizar_tramite',finalizar_tramite);


                        if(this.archivo_adjunto!=null)
                        {
                            formData.append('file',this.archivo_adjunto);
                        }
                        this.axios
                            .post(
                                process.env.VUE_APP_BACKEND + "/api/expedientes/derivacion/acciones",
                                formData,
                                {
                                    headers: {
                                        "Content-Type": "multipart/form-data"
                                    },
                                }
                            )
                            .then(response => {
                                if (response.data.success) {
                                    this.$swal("OK", "Se envio el mensaje", "success");
                                    this.$emit("accioncompleta");
                                }
                            })
                            .catch(() => {
                                this.$swal("error", "Error", "error");
                            })
                            .finally(() => {
                                this.isLoading = false;
                                this.loadItems();
                            });


                    }
                })
            },
            // eslint-disable-next-line no-unused-vars
            accionOficinaExterna(accion){
                if(this.oficina_externa==''){
                    this.$swal('Cuidado','Seleccione una oficina','warning');
                    return;
                }
                this.$swal.fire({
                    title: '¿Esta seguro de derivar?',
                    text: "Se derivara a la oficina externa seleccionada",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Si.'
                }).then((result) => {
                    if (result.isConfirmed) {

                        this.isLoading=true;
                        this.axios.post(process.env.VUE_APP_BACKEND + "/api/expedientes/derivacion/acciones",
                            {
                                'expediente_id':this.data.id,
                                'tipo_detalle':'oficina_externa',
                                'oficina_externa':this.oficina_externa,
                                'observacion_oficina_externa':this.observacion_oficina_externa,
                                'accion':accion
                        })
                        .then((response)=>{
                            this.$swal.fire(
                                'Ok',
                                'Se completo la accion.',
                                'success'
                            );
                            console.log(response);

                        })
                         .catch(()=>this.$swal('error','Ocurrio un error en el servidor','error'))
                        .finally(()=>this.isLoading=false);


                    }
                })

            },

            derivar(){
                if(this.model.oficina_id ==null){
                    this.$swal("Cuidado", "Seleccione una oficina", "warning");
                    return;
                }
                this.isLoading=true;
                this.model.id=this.data.id;
                this.rows_process.push(this.model);
                let formData = new FormData();
                this.model_save = Object.assign({}, this.rows_process);
                Object.keys(this.model_save).forEach(key => {
                    const data = JSON.stringify(this.model_save[key]);
                    formData.append(key,data);
                    // ...
                });
                if(this.model.file!=null)
                {
                    formData.append('file['+this.data.id+'][]',this.model.file);
                }
                this.axios
                    .post(
                        process.env.VUE_APP_BACKEND + "/api/expedientes/procesar",
                        formData,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data"
                            },
                        }
                    )
                    .then(response => {
                        if (response.data.success) {
                            this.$swal("OK", "Se recepciono los expedientes", "success");
                        }
                    })
                    .catch(() => {
                        this.$swal("error", "Error", "error");
                    })
                    .finally(() => {
                        this.isLoading = false;
                        this.loadItems();
                    });
            }
        },
        mounted() {
            this.axios.get(process.env.VUE_APP_BACKEND + '/api/usuarios')
                .then(response=>{
                    this.usuarios=response.data;
                });
        }
    }
</script>

<style scoped>

</style>